export const orgNameValidation = [
    (input) => input.trim().length < 3 ? 'Organization name should be at least 3 letters' : null,
    (input) => input.trim().length > 25 ? 'Organization name should not be more than 25 letters' : null,
    (input) => /^(?=.*[^\W_])[\w ]*$/.test(input) ? null : 'Only English letters and numbers, please',
]